import cliftonPic from "@/public/images/artists/clifton.png";
import { Artist } from "@/types/types";

export const clifton = {
  id: "188",
  name: "Clifton",
  image: cliftonPic,
  description: `Clifton's voice is a powerful baritone with a commanding vocal weight that cuts cleanly through dense, bass-heavy productions. Great for both rhythmic and melodic styles across reggae, hip-hop, and experimental genres.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fclifton-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Deep"],
      secondary: ["Reggae", "Processed"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 43,
        high: 58,
      },
      sweetSpot: 48,
    },
  },
} as const satisfies Artist;
